import {
  OVERSPEED_DATA,
  GET_RTO_VLTD_INSTALLATION_REPORT,
  GET_VLTD_INSTALLATION_REPORT,
  GET_RFC_VLTD_INSTALLATION_REPORT,
  GET_DEVICE_STATUS_REPORT,
  GET_RTO_VERIFICATION_DEVICE_REPORT,
  GET_DEVICE_AUDIT_REPORT,
  GET_DEVICE_OFFLINE_INTIMATION_REPORT,
  GET_SIM_MANUFACTURER_ACTIVITIES,
  GET_GEOFENCE_ALERT_REPORT,
  GET_ROUTEFENCE_ALERT_REPORT,
  GET_TICKET_PERFORMANCE_STATS_REPORT,
  GET_DEVICE_OVERSPEED_REPORT,
  GET_DEVICE_PANIC_HISTORY_REPORT,
  GET_NONWORKING_SLOT_ALERT_REPORT,
  GET_DEVICE_HEALTH_REPORT,
  GET_DEVICE_ALERT_REPORT,
  GET_EMP_DOC_REJECTED_REPORT,
  GET_UNMAP_DEVICE_REPORT,
  GET_EMAIL_ACTIVITIES_REPORT,
  GET_INSUFFICIENT_STOCK_REPORT,
  GET_SERVER_LOGS,
  GET_USER_ACTIVITIES,
  GET_ERSS_SIGNAL_LOGS,
  GET_INSTALLATION_DEVICE_REPORT,
  GET_GLOBAL_SERVER_LOGS,
  GET_OFFLINE_DEVICE_HISTORY_REPORT,
  GET_INVALID_VLTD_ONLINE_REPORT,
  GET_INVALID_TICKET_REPORT,
  GET_RTO_REVERIFICATION_REPORT,
  GET_ALERT_TYPES,
  GET_DEVICE_CUMULATIVE_OVERSPEED_REPORT,
  GET_DEVICE_PANIC_HISTORY_CUMULATIVE_REPORT,
  SOFTWARE_NOTIFICATION_REPORT,
  GET_OFFLINE_DEVICE_MONTHLY_REPORT,
  GET_EXPIRED_INSTALLATION_REPORT,
} from "../actions/types";

const initialState = {
  overSpeedReportData: [],
  rtoVltdInstallationReportData: [],
  vltdInstallationReportData: [],
  rfcVltdInstallationReportData: [],
  deviceStatusReportData: [],
  rtoVerificationDeviceReportData: [],
  deviceAuditReportData: [],
  offlineIntimationReportData: [],
  simManufacturerActivitiesData: [],
  geofenceAlertData: [],
  routefenceAlertData: [],
  ticketPerformanceStatsData: [],
  deviceOverspeedData: [],
  devicePanicHistoryData: [],
  nonWorkingSlotAlertData: [],
  deviceHealthData: [],
  deviceAlertData: [],
  alertTypesData: [],
  empDocRejectedData: [],
  unmapDeviceData: [],
  emailActivitiesData: [],
  insufficientStockData: [],
  serverLogsData: [],
  userActivitiesData: [],
  erssSignalLogsData: [],
  globalServerLogsData: [],
  offlineDeviceReportData: [],
  invalidVltdOnlineReportData: [],
  offlineDeviceMonthlyData: [],
  expiredInstallationReportData: [],
};

const overSpeedReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case OVERSPEED_DATA:
      return {
        ...state,
        overSpeedReportData: payload,
      };

    default:
      return state;
  }
};

const reportStatsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_RTO_VLTD_INSTALLATION_REPORT:
      return {
        ...state,
        rtoVltdInstallationReportData: payload,
      };
    case GET_VLTD_INSTALLATION_REPORT:
      return {
        ...state,
        vltdInstallationReportData: payload,
      };
    case GET_RFC_VLTD_INSTALLATION_REPORT:
      return {
        ...state,
        rfcVltdInstallationReportData: payload,
      };
    default:
      return state;
  }
};

const reportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DEVICE_STATUS_REPORT:
      return {
        ...state,
        deviceStatusReportData: payload,
      };
    case GET_RTO_VERIFICATION_DEVICE_REPORT:
      return {
        ...state,
        rtoVerificationDeviceReportData: payload,
      };
    case GET_INSTALLATION_DEVICE_REPORT:
      return {
        ...state,
        installationDeviceReportData: payload,
      };
    case GET_RTO_REVERIFICATION_REPORT:
      return {
        ...state,
        rtoReverificationReport: payload,
      };
    case GET_EXPIRED_INSTALLATION_REPORT:
      return {
        ...state,
        expiredInstallationReportData: payload,
      };

    default:
      return state;
  }
};
const offlineDeviceReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_OFFLINE_DEVICE_HISTORY_REPORT:
      return {
        ...state,
        offlineDeviceReportData: payload,
      };
    case GET_INVALID_VLTD_ONLINE_REPORT:
      return {
        ...state,
        invalidVltdOnlineReportData: payload,
      };
    default:
      return state;
  }
};

const auditReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DEVICE_AUDIT_REPORT:
      return {
        ...state,
        deviceAuditReportData: payload,
      };
    case GET_DEVICE_OFFLINE_INTIMATION_REPORT:
      return {
        ...state,
        offlineIntimationReportData: payload,
      };
    case GET_SIM_MANUFACTURER_ACTIVITIES:
      return {
        ...state,
        simManufacturerActivitiesData: payload,
      };
    default:
      return state;
  }
};

const fencingReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_GEOFENCE_ALERT_REPORT:
      return {
        ...state,
        geofenceAlertData: payload,
      };
    case GET_ROUTEFENCE_ALERT_REPORT:
      return {
        ...state,
        routefenceAlertData: payload,
      };
    case GET_TICKET_PERFORMANCE_STATS_REPORT:
      return {
        ...state,
        ticketPerformanceStatsData: payload,
      };

    default:
      return state;
  }
};

const alertReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DEVICE_OVERSPEED_REPORT:
      return {
        ...state,
        deviceOverspeedData: payload,
      };
    case GET_DEVICE_PANIC_HISTORY_REPORT:
      return {
        ...state,
        devicePanicHistoryData: payload,
      };
    case GET_DEVICE_PANIC_HISTORY_CUMULATIVE_REPORT:
      return {
        ...state,
        devicePanicHistoryCumulativeData: payload,
      };
    case GET_NONWORKING_SLOT_ALERT_REPORT:
      return {
        ...state,
        nonWorkingSlotAlertData: payload,
      };
    case GET_DEVICE_HEALTH_REPORT:
      return {
        ...state,
        deviceHealthData: payload,
      };
    case GET_DEVICE_ALERT_REPORT:
      return {
        ...state,
        deviceAlertData: payload,
      };
    case GET_ALERT_TYPES:
      return {
        ...state,
        alertTypesData: payload,
      };
    case GET_DEVICE_CUMULATIVE_OVERSPEED_REPORT:
      return {
        ...state,
        cumulativeOverspeedData: payload,
      };

    default:
      return state;
  }
};

const logsReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_EMP_DOC_REJECTED_REPORT:
      return {
        ...state,
        empDocRejectedData: payload,
      };
    case GET_UNMAP_DEVICE_REPORT:
      return {
        ...state,
        unmapDeviceData: payload,
      };
    case GET_EMAIL_ACTIVITIES_REPORT:
      return {
        ...state,
        emailActivitiesData: payload,
      };
    case GET_INSUFFICIENT_STOCK_REPORT:
      return {
        ...state,
        insufficientStockData: payload,
      };
    case GET_SERVER_LOGS:
      return {
        ...state,
        serverLogsData: payload,
      };
    case GET_GLOBAL_SERVER_LOGS:
      return {
        ...state,
        globalServerLogsData: payload,
      };
    case GET_USER_ACTIVITIES:
      return {
        ...state,
        userActivitiesData: payload,
      };

    case GET_ERSS_SIGNAL_LOGS:
      return {
        ...state,
        erssSignalLogsData: payload,
      };
    default:
      return state;
  }
};

const InvalidTicketReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_INVALID_TICKET_REPORT:
      return {
        ...state,
        InvalidTicketData: payload,
      };

    default:
      return state;
  }
};
const NotificationReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SOFTWARE_NOTIFICATION_REPORT:
      return {
        ...state,
        NotificationData: payload,
      };

    default:
      return state;
  }
};
const OfflineDeviceMonthlyReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_OFFLINE_DEVICE_MONTHLY_REPORT:
      return {
        ...state,
        offlineDeviceMonthlyData: payload,
      };

    default:
      return state;
  }
};
export {
  overSpeedReportReducer,
  reportStatsReducer,
  reportReducer,
  auditReportReducer,
  fencingReportReducer,
  alertReportReducer,
  logsReportReducer,
  offlineDeviceReportReducer,
  InvalidTicketReducer,
  NotificationReportReducer,
  OfflineDeviceMonthlyReportReducer,
};
